// Retail.js

// Sales Department Risks (20 records)
const salesRiskData = [
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-001',
    riskDescription: 'Delayed revenue recognition due to late invoicing.',
    riskCause: ['Inefficient billing processes', 'Delayed data entry'],
    consequence: 'Revenue underreporting may lead to misstatements in financial reports.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-SAL-001',
    processControlDescription: 'Standardize invoicing procedures and implement automated reminders.',
    processControlDesign: 'system dependent',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Delayed invoice processing', 'Data entry errors'],
    auditTestingProcedures: ['Test invoice cutoff dates', 'Reconcile sales transactions with invoicing system']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-002',
    riskDescription: 'Inaccurate sales reporting due to manual entry errors.',
    riskCause: ['Human error', 'Lack of verification procedures'],
    consequence: 'Incorrect revenue figures affecting decision making.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-SAL-002',
    processControlDescription: 'Implement dual verification on manual entries and periodic audits.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Entry mistakes', 'Omitted sales data'],
    auditTestingProcedures: ['Sample sales entries and verify against source documents', 'Review error logs']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-003',
    riskDescription: 'Overstated sales due to duplicate entries in the system.',
    riskCause: ['System integration issues', 'Data duplication errors'],
    consequence: 'Inflated revenue figures leading to inaccurate forecasts.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-SAL-003',
    processControlDescription: 'Implement automated de-duplication checks in the sales system.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Weekly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Duplicate records', 'Inconsistent data synchronization'],
    auditTestingProcedures: ['Check for duplicate entries in sales records', 'Perform data integrity tests']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-004',
    riskDescription: 'Misclassification of discounts affecting net revenue.',
    riskCause: ['Improper discount coding', 'Lack of oversight'],
    consequence: 'Net revenue misstatement affecting financial performance analysis.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-SAL-004',
    processControlDescription: 'Establish clear discount coding guidelines and monitor discount applications.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Misapplied discount codes', 'Inaccurate discount reporting'],
    auditTestingProcedures: ['Review discount applications in transactions', 'Verify compliance with guidelines']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-005',
    riskDescription: 'Loss of sales data due to system outages.',
    riskCause: ['IT system failures', 'Inadequate backup procedures'],
    consequence: 'Incomplete sales records affecting revenue reporting.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-005',
    processControlDescription: 'Implement robust backup and disaster recovery processes.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Data loss incidents', 'Delayed recoveries'],
    auditTestingProcedures: ['Test backup restoration processes', 'Review outage logs']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-006',
    riskDescription: 'Delayed commission calculations causing payment disputes.',
    riskCause: ['Complex commission structure', 'Manual calculation errors'],
    consequence: 'Employee dissatisfaction and delayed payouts.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-006',
    processControlDescription: 'Automate commission calculations and validate with sample testing.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Calculation discrepancies', 'Delayed commission payments'],
    auditTestingProcedures: ['Recalculate commissions on sample data', 'Review commission reports']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-007',
    riskDescription: 'Inefficient lead management causing missed sales opportunities.',
    riskCause: ['Lack of follow-up procedures', 'Poor CRM integration'],
    consequence: 'Reduced revenue from missed sales leads.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-007',
    processControlDescription: 'Improve CRM integration and enforce follow-up protocols.',
    processControlDesign: 'system dependent',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Missed follow-ups', 'Delayed data entry'],
    auditTestingProcedures: ['Monitor CRM follow-up rates', 'Review conversion metrics']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-008',
    riskDescription: 'Inconsistent sales techniques due to inadequate training.',
    riskCause: ['Insufficient training programs', 'High employee turnover'],
    consequence: 'Variable performance and reduced customer satisfaction.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-008',
    processControlDescription: 'Enhance sales training and monitor performance metrics.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Quarterly',
    processControlOwner: 'HR Manager',
    expectedDeviations: ['Low training attendance', 'Poor sales performance'],
    auditTestingProcedures: ['Review training records', 'Evaluate sales outcomes']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-009',
    riskDescription: 'Overreliance on manual order entry causing errors.',
    riskCause: ['Manual processes', 'Lack of automation'],
    consequence: 'Order processing errors leading to customer dissatisfaction.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-009',
    processControlDescription: 'Introduce order automation and verify order accuracy.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Order entry mistakes', 'Delayed processing'],
    auditTestingProcedures: ['Review order logs', 'Test automated processing']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-010',
    riskDescription: 'Lack of customer feedback integration affecting strategy.',
    riskCause: ['Inadequate feedback collection', 'Failure to act on insights'],
    consequence: 'Misaligned sales strategy and missed market opportunities.',
    riskCategory: 'Strategic',
    processControlId: 'CTRL-SAL-010',
    processControlDescription: 'Implement a robust customer feedback loop.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Strategic',
    frequency: 'Quarterly',
    processControlOwner: 'Marketing Manager',
    expectedDeviations: ['Limited feedback data', 'Slow response'],
    auditTestingProcedures: ['Review feedback reports', 'Assess strategy adjustments']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-011',
    riskDescription: 'Inefficient pricing strategy leading to revenue leakage.',
    riskCause: ['Lack of market analysis', 'Poor pricing models'],
    consequence: 'Revenue loss due to improper pricing.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-SAL-011',
    processControlDescription: 'Regularly review and adjust pricing based on market data.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Pricing Manager',
    expectedDeviations: ['Incorrect pricing', 'Inconsistent discounts'],
    auditTestingProcedures: ['Analyze pricing trends', 'Compare with benchmarks']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-012',
    riskDescription: 'Delayed sales cycle due to cumbersome approval processes.',
    riskCause: ['Excessive approval layers', 'Inefficient decision making'],
    consequence: 'Lost sales opportunities due to slow approvals.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-012',
    processControlDescription: 'Streamline approval processes to expedite sales cycles.',
    processControlDesign: 'system dependent',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Slow approvals', 'Process bottlenecks'],
    auditTestingProcedures: ['Review approval timelines', 'Assess process efficiency']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-013',
    riskDescription: 'Inconsistent customer data impacting targeted marketing efforts.',
    riskCause: ['Fragmented data systems', 'Lack of data standardization'],
    consequence: 'Ineffective marketing and lost sales opportunities.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-013',
    processControlDescription: 'Integrate customer data into a unified system.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Marketing Manager',
    expectedDeviations: ['Data discrepancies', 'Poor segmentation'],
    auditTestingProcedures: ['Review data integration processes', 'Test segmentation accuracy']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-014',
    riskDescription: 'Over-dependence on key accounts causing revenue concentration.',
    riskCause: ['Lack of account diversification', 'Insufficient market reach'],
    consequence: 'Revenue vulnerability from loss of major customers.',
    riskCategory: 'Strategic',
    processControlId: 'CTRL-SAL-014',
    processControlDescription: 'Diversify the customer base and monitor key account performance.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Strategic',
    frequency: 'Quarterly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Revenue concentration', 'Dependency risks'],
    auditTestingProcedures: ['Analyze revenue distribution', 'Review key account practices']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-015',
    riskDescription: 'Ineffective sales incentives misaligning employee goals.',
    riskCause: ['Poorly structured incentive programs', 'Lack of performance tracking'],
    consequence: 'Reduced motivation and misaligned sales efforts.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-015',
    processControlDescription: 'Review and adjust incentive programs to align with targets.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'HR Manager',
    expectedDeviations: ['Inadequate incentives', 'Inconsistent tracking'],
    auditTestingProcedures: ['Evaluate incentive effectiveness', 'Review performance data']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-016',
    riskDescription: 'Poor integration of online and offline channels affecting sales.',
    riskCause: ['Disparate systems', 'Lack of unified data'],
    consequence: 'Inconsistent customer experience and revenue leakage.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-016',
    processControlDescription: 'Implement an integrated omni-channel platform.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Data gaps', 'Customer experience issues'],
    auditTestingProcedures: ['Test system integration', 'Review channel performance']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-017',
    riskDescription: 'Lack of proactive forecasting resulting in order issues.',
    riskCause: ['Inadequate market analysis', 'Reactive planning'],
    consequence: 'Inventory mismatches and missed sales opportunities.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-017',
    processControlDescription: 'Implement proactive forecasting tools and training.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Sales Manager',
    expectedDeviations: ['Forecast errors', 'Reactive planning'],
    auditTestingProcedures: ['Compare forecasts with actual sales', 'Review forecasting methods']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-018',
    riskDescription: 'Lack of supply chain integration affecting order fulfillment.',
    riskCause: ['Poor inter-department coordination', 'Incompatible systems'],
    consequence: 'Delayed order fulfillment and customer dissatisfaction.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-018',
    processControlDescription: 'Enhance supply chain integration with real-time tracking.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Delayed fulfillment', 'Communication gaps'],
    auditTestingProcedures: ['Review order processing times', 'Check integration logs']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-019',
    riskDescription: 'Complex contract terms deterring potential customers.',
    riskCause: ['Overly legalistic contract language', 'Inflexible terms'],
    consequence: 'Loss of sales and negative customer perceptions.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-019',
    processControlDescription: 'Simplify contract terms and train sales staff on negotiation.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Quarterly',
    processControlOwner: 'Legal Department',
    expectedDeviations: ['Contract negotiation delays', 'Customer pushback'],
    auditTestingProcedures: ['Review contract templates', 'Assess negotiation outcomes']
  },
  {
    industry: 'Retail',
    department: 'Sales',
    riskId: 'SAL-020',
    riskDescription: 'Ineffective post-sale support affecting repeat business.',
    riskCause: ['Lack of customer relationship management', 'Insufficient follow-up'],
    consequence: 'Reduced customer loyalty and lower repeat sales.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-SAL-020',
    processControlDescription: 'Establish robust post-sale support and feedback channels.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Customer Service Manager',
    expectedDeviations: ['Poor follow-up', 'Low engagement'],
    auditTestingProcedures: ['Review support logs', 'Analyze repeat sales data']
  }
];

// Inventory Department Risks (20 records)
const inventoryRiskData = [
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-001',
    riskDescription: 'Scanning errors resulting in inaccurate stock counts.',
    riskCause: ['Faulty barcode scanners', 'Operator error'],
    consequence: 'Stockouts or overstock situations affecting sales.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-001',
    processControlDescription: 'Calibrate scanners regularly and provide operator training.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Inaccurate counts', 'Delayed updates'],
    auditTestingProcedures: ['Compare physical stock with records', 'Monitor scanner performance']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-002',
    riskDescription: 'Data sync issues between POS and inventory systems.',
    riskCause: ['System integration errors', 'Network latency'],
    consequence: 'Mismatched inventory records leading to order errors.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-002',
    processControlDescription: 'Implement real-time data synchronization between systems.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Data lags', 'Record mismatches'],
    auditTestingProcedures: ['Review synchronization logs', 'Test update speeds']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-003',
    riskDescription: 'Manual adjustments causing discrepancies in stock counts.',
    riskCause: ['Unauthorized adjustments', 'Lack of audit trails'],
    consequence: 'Inaccurate inventory valuation and reporting errors.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-003',
    processControlDescription: 'Implement strict controls and maintain audit trails for adjustments.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Unauthorized changes', 'Poor documentation'],
    auditTestingProcedures: ['Review adjustment logs', 'Test control effectiveness']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-004',
    riskDescription: 'Delayed stock reconciliation due to manual processes.',
    riskCause: ['Inefficient manual reconciliation', 'Lack of automation'],
    consequence: 'Late detection of stock discrepancies.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-004',
    processControlDescription: 'Automate stock reconciliation processes for timely updates.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Late reconciliations', 'Inaccurate adjustments'],
    auditTestingProcedures: ['Verify reconciliation reports', 'Test automated processes']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-005',
    riskDescription: 'Misplaced items leading to inventory shrinkage.',
    riskCause: ['Poor storage organization', 'Theft or loss'],
    consequence: 'Shrinkage impacting inventory valuation and margins.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-005',
    processControlDescription: 'Implement organized storage and periodic physical counts.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Unrecorded losses', 'Variances in counts'],
    auditTestingProcedures: ['Conduct surprise counts', 'Review variance reports']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-006',
    riskDescription: 'Errors in stock transfers between locations.',
    riskCause: ['Data entry mistakes', 'Communication breakdown'],
    consequence: 'Stock imbalances across stores leading to lost sales.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-006',
    processControlDescription: 'Standardize transfer procedures and verify transfers.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Transfer errors', 'Inaccurate records'],
    auditTestingProcedures: ['Review transfer documents', 'Reconcile inter-store records']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-007',
    riskDescription: 'Overstocking due to miscalculated reorder points.',
    riskCause: ['Inaccurate forecasting', 'Incorrect system settings'],
    consequence: 'Excess inventory tying up capital.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-007',
    processControlDescription: 'Regularly review and adjust reorder points based on demand.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Excess stock', 'Forecast errors'],
    auditTestingProcedures: ['Analyze inventory turnover', 'Test reorder calculations']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-008',
    riskDescription: 'Delayed response to out-of-stock items.',
    riskCause: ['Inefficient alert systems', 'Poor communication'],
    consequence: 'Lost sales due to unavailable products.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-008',
    processControlDescription: 'Implement automated alerts for out-of-stock items.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Daily',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Delayed alerts', 'Missed signals'],
    auditTestingProcedures: ['Review alert logs', 'Test notification systems']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-009',
    riskDescription: 'Inaccurate forecast adjustments causing inventory misalignment.',
    riskCause: ['Improper forecast revisions', 'Data entry errors'],
    consequence: 'Inventory levels not matching demand trends.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-009',
    processControlDescription: 'Improve forecasting accuracy with regular reviews.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Forecast inaccuracies', 'Inventory mismatches'],
    auditTestingProcedures: ['Review forecasting methods', 'Compare forecasts with actuals']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-010',
    riskDescription: 'System errors causing incorrect inventory valuations.',
    riskCause: ['Software bugs', 'Integration issues'],
    consequence: 'Misstated inventory affecting financial reporting.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-010',
    processControlDescription: 'Conduct regular system maintenance and checks.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Weekly',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Valuation errors', 'Data discrepancies'],
    auditTestingProcedures: ['Test system accuracy', 'Review update logs']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-011',
    riskDescription: 'Inventory shrinkage due to theft.',
    riskCause: ['Inadequate security', 'Poor surveillance'],
    consequence: 'Loss of inventory impacting profit margins.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-011',
    processControlDescription: 'Enhance security measures and install surveillance.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Monthly',
    processControlOwner: 'Security Manager',
    expectedDeviations: ['Theft incidents', 'Unrecorded losses'],
    auditTestingProcedures: ['Review security footage', 'Compare inventory records']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-012',
    riskDescription: 'Inconsistent pricing updates affecting inventory values.',
    riskCause: ['Manual price adjustments', 'Delayed system updates'],
    consequence: 'Mismatch between actual and recorded values.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-012',
    processControlDescription: 'Automate price updates and synchronize systems.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Weekly',
    processControlOwner: 'Pricing Manager',
    expectedDeviations: ['Price mismatches', 'Delayed updates'],
    auditTestingProcedures: ['Test automated pricing', 'Review sync logs']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-013',
    riskDescription: 'Overstocking due to inaccurate demand forecasts.',
    riskCause: ['Poor forecasting methods', 'Inadequate historical data'],
    consequence: 'Excess inventory and high holding costs.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-013',
    processControlDescription: 'Enhance forecasting with advanced analytics.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Overestimation of demand', 'Excess stock'],
    auditTestingProcedures: ['Review forecast accuracy', 'Analyze turnover']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-014',
    riskDescription: 'Incorrect product categorization leading to reporting errors.',
    riskCause: ['Misclassification of items', 'Lack of standardized taxonomy'],
    consequence: 'Inaccurate sales and inventory reports.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-014',
    processControlDescription: 'Establish standard product categorization and audit regularly.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Misclassified items', 'Reporting inconsistencies'],
    auditTestingProcedures: ['Review classification processes', 'Compare reports']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-015',
    riskDescription: 'Discrepancies from manual inventory counts.',
    riskCause: ['Human error', 'Insufficient training'],
    consequence: 'Inaccurate records and potential misstatements.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-015',
    processControlDescription: 'Increase training and perform double-checks on counts.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Counting errors', 'Misreporting'],
    auditTestingProcedures: ['Conduct independent counts', 'Review variance reports']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-016',
    riskDescription: 'Loss of perishable items due to poor stock rotation.',
    riskCause: ['Improper stock rotation', 'Lack of monitoring'],
    consequence: 'Increased waste and reduced margins.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-016',
    processControlDescription: 'Implement FIFO procedures and monitor rotations.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Expired goods', 'Wastage'],
    auditTestingProcedures: ['Check FIFO compliance', 'Review rotation logs']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-017',
    riskDescription: 'Unrecorded inventory adjustments due to system lag.',
    riskCause: ['Delayed updates', 'Manual override errors'],
    consequence: 'Inaccurate records impacting financial reporting.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-017',
    processControlDescription: 'Increase system update frequency and log overrides.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Late updates', 'Unlogged changes'],
    auditTestingProcedures: ['Review system logs', 'Test update times']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-018',
    riskDescription: 'Supplier performance issues affecting stock availability.',
    riskCause: ['Supplier delays', 'Quality control problems'],
    consequence: 'Stock shortages impacting sales.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-018',
    processControlDescription: 'Establish supplier metrics and conduct regular reviews.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Procurement Manager',
    expectedDeviations: ['Supplier delays', 'Quality issues'],
    auditTestingProcedures: ['Review supplier reports', 'Assess delivery performance']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-019',
    riskDescription: 'Inaccurate pricing affecting inventory valuation.',
    riskCause: ['Delayed price updates', 'Manual errors'],
    consequence: 'Misstated inventory values affecting reports.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-019',
    processControlDescription: 'Automate pricing updates and audit regularly.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Weekly',
    processControlOwner: 'Pricing Manager',
    expectedDeviations: ['Price mismatches', 'Data errors'],
    auditTestingProcedures: ['Test pricing system', 'Review audit logs']
  },
  {
    industry: 'Retail',
    department: 'Inventory',
    riskId: 'INV-020',
    riskDescription: 'Excess inventory buildup due to over-ordering.',
    riskCause: ['Poor demand forecasting', 'Lack of order controls'],
    consequence: 'High holding costs and potential obsolescence.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-020',
    processControlDescription: 'Implement demand forecasting tools and review orders regularly.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Excess stock', 'Forecast errors'],
    auditTestingProcedures: ['Review order records', 'Compare forecasts with actual sales']
  }
];

// Store Operations Department Risks (20 records)
const operationsRiskData = [
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-001',
    riskDescription: 'Inefficient store layout reducing customer throughput.',
    riskCause: ['Poor design', 'Inadequate signage'],
    consequence: 'Reduced customer flow and lower sales.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-001',
    processControlDescription: 'Redesign store layout and improve signage for better flow.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Quarterly',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Customer congestion', 'Confusing layout'],
    auditTestingProcedures: ['Conduct layout reviews', 'Gather customer feedback']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-002',
    riskDescription: 'Understaffing due to inadequate scheduling.',
    riskCause: ['Poor scheduling tools', 'Forecast errors'],
    consequence: 'Reduced service levels and increased wait times.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-002',
    processControlDescription: 'Implement advanced scheduling software and monitor staffing levels.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Staffing shortages', 'Overlapping shifts'],
    auditTestingProcedures: ['Review scheduling reports', 'Monitor attendance']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-003',
    riskDescription: 'Long checkout times due to outdated POS systems.',
    riskCause: ['Outdated technology', 'Insufficient staff training'],
    consequence: 'Customer frustration and abandoned purchases.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-003',
    processControlDescription: 'Upgrade POS systems and enhance training for cashiers.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Slow checkouts', 'Transaction delays'],
    auditTestingProcedures: ['Monitor POS performance', 'Review transaction times']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-004',
    riskDescription: 'Poor customer service due to inadequate training.',
    riskCause: ['Lack of regular training', 'High turnover rates'],
    consequence: 'Low customer satisfaction and loss of repeat business.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-004',
    processControlDescription: 'Enhance customer service training programs and monitor performance.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'HR Manager',
    expectedDeviations: ['Service inconsistencies', 'Low training participation'],
    auditTestingProcedures: ['Review training records', 'Conduct customer surveys']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-005',
    riskDescription: 'Inefficient restocking leading to empty shelves.',
    riskCause: ['Delayed deliveries', 'Poor coordination'],
    consequence: 'Lost sales due to unavailable products.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-005',
    processControlDescription: 'Streamline restocking procedures and improve supplier coordination.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Restocking delays', 'Inventory shortages'],
    auditTestingProcedures: ['Review restocking logs', 'Verify supplier performance']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-006',
    riskDescription: 'High energy costs due to inefficient systems.',
    riskCause: ['Inefficient lighting', 'Outdated HVAC'],
    consequence: 'Increased overhead reducing profitability.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-OPS-006',
    processControlDescription: 'Upgrade to energy-efficient systems and monitor consumption.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Quarterly',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['High energy bills', 'Inefficient systems'],
    auditTestingProcedures: ['Review energy usage reports', 'Test system efficiency']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-007',
    riskDescription: 'Security weaknesses exposing store assets.',
    riskCause: ['Lack of surveillance', 'Poor access controls'],
    consequence: 'Increased theft risk and asset loss.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-007',
    processControlDescription: 'Enhance security protocols with surveillance and access controls.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Security Manager',
    expectedDeviations: ['Security breaches', 'Asset misappropriation'],
    auditTestingProcedures: ['Review security logs', 'Conduct physical audits']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-008',
    riskDescription: 'Poor facility maintenance creating safety hazards.',
    riskCause: ['Neglected maintenance schedules', 'Lack of audits'],
    consequence: 'Increased risk of accidents and liability issues.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-008',
    processControlDescription: 'Establish regular maintenance and safety inspections.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Maintenance delays', 'Safety non-compliance'],
    auditTestingProcedures: ['Review maintenance logs', 'Conduct safety inspections']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-009',
    riskDescription: 'Delayed resolution of customer complaints harming reputation.',
    riskCause: ['Inefficient complaint handling', 'Lack of dedicated support'],
    consequence: 'Negative impact on customer loyalty.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-009',
    processControlDescription: 'Implement a dedicated customer service desk and timely complaint resolution protocols.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Customer Service Manager',
    expectedDeviations: ['Slow response', 'Unresolved issues'],
    auditTestingProcedures: ['Review complaint logs', 'Monitor resolution times']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-010',
    riskDescription: 'Inefficient cash management causing float shortages.',
    riskCause: ['Poor cash handling', 'Inadequate reconciliation'],
    consequence: 'Cash shortfalls impacting daily operations.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-OPS-010',
    processControlDescription: 'Implement strict cash handling and reconciliation procedures.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Daily',
    processControlOwner: 'Store Manager',
    expectedDeviations: ['Cash discrepancies', 'Insufficient float'],
    auditTestingProcedures: ['Review cash registers', 'Conduct surprise cash counts']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-011',
    riskDescription: 'Lack of contingency planning for emergencies in store.',
    riskCause: ['Insufficient emergency protocols', 'Lack of training'],
    consequence: 'Inadequate response to emergencies risking safety.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-011',
    processControlDescription: 'Develop and regularly update emergency plans and conduct drills.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Quarterly',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Unpreparedness', 'Slow response'],
    auditTestingProcedures: ['Review emergency plans', 'Observe drill performance']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-012',
    riskDescription: 'Inadequate vendor management affecting service quality.',
    riskCause: ['Lack of performance metrics', 'Poor contract management'],
    consequence: 'Service disruptions and lower quality in-store services.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-012',
    processControlDescription: 'Establish vendor evaluation criteria and conduct regular reviews.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Vendor delays', 'Quality issues'],
    auditTestingProcedures: ['Review vendor contracts', 'Monitor performance metrics']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-013',
    riskDescription: 'Inefficient store opening procedures causing delays.',
    riskCause: ['Poor coordination', 'Inefficient setup processes'],
    consequence: 'Delayed openings impacting revenue generation.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-013',
    processControlDescription: 'Streamline opening procedures with checklists and coordination.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'One-time per opening',
    processControlOwner: 'Store Manager',
    expectedDeviations: ['Opening delays', 'Incomplete setup'],
    auditTestingProcedures: ['Review opening checklists', 'Interview managers']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-014',
    riskDescription: 'Excessive shrinkage due to poor inventory management.',
    riskCause: ['Weak inventory controls', 'Theft or administrative errors'],
    consequence: 'Loss of revenue and profit shrinkage.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-014',
    processControlDescription: 'Implement robust inventory tracking and shrinkage prevention measures.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Shrinkage incidents', 'Unexplained variances'],
    auditTestingProcedures: ['Conduct surprise audits', 'Review shrinkage reports']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-015',
    riskDescription: 'Delayed equipment maintenance leading to disruptions.',
    riskCause: ['Neglected maintenance', 'Insufficient monitoring'],
    consequence: 'Equipment failure causing store disruptions and lost sales.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-015',
    processControlDescription: 'Establish maintenance schedules and perform regular checks.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Maintenance Manager',
    expectedDeviations: ['Maintenance delays', 'Equipment breakdowns'],
    auditTestingProcedures: ['Review maintenance logs', 'Conduct inspections']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-016',
    riskDescription: 'Inconsistent service levels across different store locations.',
    riskCause: ['Variable staff performance', 'Lack of standard procedures'],
    consequence: 'Customer dissatisfaction and brand reputation damage.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-016',
    processControlDescription: 'Implement standardized service protocols and monitor performance.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Operations Manager',
    expectedDeviations: ['Service inconsistencies', 'Variable customer feedback'],
    auditTestingProcedures: ['Conduct service audits', 'Review customer surveys']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-017',
    riskDescription: 'Poorly managed promotional events causing in-store chaos.',
    riskCause: ['Inadequate event planning', 'Overcrowding during promotions'],
    consequence: 'Operational disruptions and negative customer experiences.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-017',
    processControlDescription: 'Develop detailed event plans and allocate adequate staff.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Per event',
    processControlOwner: 'Marketing Manager',
    expectedDeviations: ['Crowding issues', 'Operational chaos'],
    auditTestingProcedures: ['Review event plans', 'Assess event execution']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-018',
    riskDescription: 'Failure to update digital signage affecting promotions.',
    riskCause: ['Technical glitches', 'Outdated content management'],
    consequence: 'Ineffective promotions and reduced engagement.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-018',
    processControlDescription: 'Regularly update and test digital signage systems.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Marketing Manager',
    expectedDeviations: ['Outdated content', 'System failures'],
    auditTestingProcedures: ['Test signage updates', 'Review content schedules']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-019',
    riskDescription: 'Insufficient training on new technologies in-store.',
    riskCause: ['Lack of proper training', 'Rapid tech changes'],
    consequence: 'Operational inefficiencies and increased errors.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-019',
    processControlDescription: 'Implement comprehensive training on new store technologies.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Quarterly',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Poor tech adoption', 'Increased errors'],
    auditTestingProcedures: ['Review training records', 'Assess tech usage']
  },
  {
    industry: 'Retail',
    department: 'Store Operations',
    riskId: 'OPS-020',
    riskDescription: 'Delayed resolution of technical issues disrupting store operations.',
    riskCause: ['Inefficient IT support', 'Slow troubleshooting'],
    consequence: 'Extended downtime and operational disruptions.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-OPS-020',
    processControlDescription: 'Establish a rapid response IT support system for stores.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Delayed resolutions', 'Extended downtime'],
    auditTestingProcedures: ['Review IT support logs', 'Test response times']
  }
];

const retailRiskData = [
  ...salesRiskData,
  ...inventoryRiskData,
  ...operationsRiskData
];

export default retailRiskData;
